<style scoped lang="scss" type="text/scss">
    .left-panel-container {
        width: 18rem;
        margin-right: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        .head-avatar-image-uploader {
            .extra-info {
                display: flex;
                flex-direction: column;
                align-items: center;

                span {
                    transform: scale(.9);
                    font-size: .75rem;
                    color: #CCC;
                }
            }
        }

        .name-plate {
            margin: 1rem 0;
        }
    }
</style>

<template>
    <card class="left-panel-container">
        <i-single-image-uploader ref="uploader" class="head-avatar-image-uploader"
                                 v-model="uploadImage"
                                 :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                                 :limit-size="2 * 1024 * 1024"
                                 :circular="true"
                                 titie="头像"
                                 :src="headAvatar"
                                 @file-uploaded="fileUploaded"
        >
            <div class="extra-info">
                <span>JPG / SVG / PNG / JPEG</span>
                <span v-text="'<= 2 MB'"></span>
            </div>
        </i-single-image-uploader>
        <name-plate class="name-plate" :role="role"></name-plate>

        <account-panel></account-panel>
    </card>
</template>

<script>
    import Card from '../../../components/card/index';
    import NamePlate from '../../../components/nameplate/index';
    import NormalImage from '../../../components/normal-image';
    import AccountPanel from './account/index';
    import ShadowPlaceholder from '../../../components/shadow-placeholder/index';
    import ISingleImageUploader from '../../../components/i-uploader/single-image-uploader';

    export default {
        name: '',
        components: {
            Card,
            NamePlate,
            NormalImage,
            AccountPanel,
            ShadowPlaceholder,
            ISingleImageUploader
        },
        data () {
            return {
                uploadImage: {}
            };
        },
        computed: {
            headAvatar () {
                return this.$store.getters['user/headAvatar'];
            },
            selfInfo () {
                return this.$store.state.user.selfInfo;
            },
            role () {
                return this.selfInfo.role;
            }
        },
        methods: {
            fileUploaded (fileInfo, success, throwFail) {
                this.$normalRequest('user/updateSelfAvatar', fileInfo, '头像更新成功').then(_ => {
                    this.$store.dispatch('user/loadSelfInfo').then();
                    fileInfo.finish_callback();
                }).catch(_ => {
                    throwFail();
                    fileInfo.finish_callback();
                });
            }
        }
    };
</script>
